'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _animationHelper = require('animation-helper');

var _animationHelper2 = _interopRequireDefault(_animationHelper);

var _text = require('components/field/text');

var _text2 = _interopRequireDefault(_text);

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
	_inherits(Item, _Component);

	function Item() {
		_classCallCheck(this, Item);

		return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
	}

	_createClass(Item, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			(0, _jQuery2.default)(this.node).slideToggle();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'form-group comments-field', ref: function ref(node) {
						return _this2.node = node;
					} },
				this.props.children
			);
		}
	}]);

	return Item;
}(_react.Component);

var RegisterForEvents = function (_Component2) {
	_inherits(RegisterForEvents, _Component2);

	_createClass(RegisterForEvents, null, [{
		key: 'show',
		value: function show(container, eventData) {
			_reactDom2.default.render(_react2.default.createElement(RegisterForEvents, { event: eventData }), container);
		}
	}]);

	function RegisterForEvents(props) {
		_classCallCheck(this, RegisterForEvents);

		var _this3 = _possibleConstructorReturn(this, (RegisterForEvents.__proto__ || Object.getPrototypeOf(RegisterForEvents)).call(this, props));

		_this3.state = {
			name: "",
			phone: "",
			email: "",
			questions: {},
			guests: [],
			submitting: false,
			submitted: false
		};
		_this3.props.event.globalQuestions.forEach(function (q) {
			return _this3.state.questions[q] = "";
		});
		_this3.props.event.guestQuestions.forEach(function (q) {
			return _this3.state.questions[q] = "";
		});
		return _this3;
	}

	_createClass(RegisterForEvents, [{
		key: 'render',
		value: function render() {
			var _this4 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'services-form form' },
				_react2.default.createElement(
					'h3',
					null,
					'Register for this Event'
				),
				!this.state.submitted ? _react2.default.createElement(
					'div',
					{ className: 'form-wrapper', ref: function ref(node) {
							return _this4.formWrapper = _this4;
						} },
					_react2.default.createElement(
						'div',
						{ className: 'form-field-container col-md-8 col-xs-12' },
						_react2.default.createElement(
							'div',
							{ className: 'form-group' },
							_react2.default.createElement(_text2.default, { label: 'Name *', inputClassName: 'form-control', value: this.state.name, setValue: function setValue(value) {
									return _this4.setState({ name: value });
								} })
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-group' },
							_react2.default.createElement(_text2.default, { label: 'Phone *', inputClassName: 'form-control', value: this.state.phone, setValue: function setValue(value) {
									return _this4.setState({ phone: value });
								} })
						),
						_react2.default.createElement(
							'div',
							{ className: 'form-group' },
							_react2.default.createElement(_text2.default, { label: 'Email *', inputClassName: 'form-control', value: this.state.email, setValue: function setValue(value) {
									return _this4.setState({ email: value });
								} })
						),
						this.props.event.globalQuestions.map(function (question) {
							return _react2.default.createElement(
								'div',
								{ className: 'form-group', key: question },
								_react2.default.createElement(_text2.default, { label: question, inputClassName: 'form-control', value: _this4.state.questions[question], setValue: function setValue(value) {
										return _this4.setGlobalQuestion(question, value);
									} })
							);
						}),
						this.props.event.guestQuestions.map(function (question) {
							return _react2.default.createElement(
								'div',
								{ className: 'form-group', key: question },
								_react2.default.createElement(_text2.default, { label: question, inputClassName: 'form-control', value: _this4.state.questions[question], setValue: function setValue(value) {
										return _this4.setGlobalQuestion(question, value);
									} })
							);
						}),
						this.state.guests.map(function (guest, index) {
							if (_this4.props.event.guestQuestions.length) {
								return _react2.default.createElement(
									'div',
									{ key: index, className: 'guest' },
									_react2.default.createElement(
										Item,
										null,
										_react2.default.createElement(_text2.default, { label: 'Guest Name *', inputClassName: 'form-control', value: guest.name, setValue: function setValue(value) {
												return _this4.setGuestName(index, value);
											} })
									),
									_this4.props.event.guestQuestions.map(function (question) {
										return _react2.default.createElement(
											Item,
											{ key: question },
											_react2.default.createElement(_text2.default, { label: question, inputClassName: 'form-control', value: guest.questions[question], setValue: function setValue(value) {
													return _this4.setGuestQuestion(index, question, value);
												} })
										);
									})
								);
							}
							return _react2.default.createElement(
								Item,
								{ key: index },
								_react2.default.createElement(_text2.default, { label: 'Guest Name', inputClassName: 'form-control', value: guest.name, setValue: function setValue(value) {
										return _this4.setGuestName(index, value);
									} })
							);
						}),
						_react2.default.createElement(
							'a',
							{ className: 'add-comments-link', onClick: function onClick() {
									return _this4.addGuest();
								} },
							'+ Add Another Guest'
						)
					),
					_react2.default.createElement(
						'button',
						{ className: 'btn submit-form-btn', disabled: !this.canSubmit, onClick: function onClick() {
								return _this4.submit();
							} },
						'Register'
					),
					this.state.submitting ? _react2.default.createElement('div', { className: 'submit-overlay', ref: function ref(node) {
							return node && node.focus();
						} }) : null
				) : _react2.default.createElement(
					'div',
					{ className: 'form-wrapper submitted', ref: function ref(node) {
							return _this4.formWrapper = _this4;
						} },
					_react2.default.createElement(
						'h4',
						null,
						'Thank you for your submission!'
					)
				)
			);
		}
	}, {
		key: 'addGuest',
		value: function addGuest() {
			var G = { name: "", questions: {} };
			this.props.event.guestQuestions.forEach(function (Q) {
				return G.questions[Q] = "";
			});
			this.setState(function (state) {
				return { guests: state.guests.concat(G) };
			});
		}
	}, {
		key: 'setGuestName',
		value: function setGuestName(index, value) {
			this.setState(function (state) {
				var G = state.guests.slice();
				G[index].name = value;
				return { guests: G };
			});
		}
	}, {
		key: 'setGuestQuestion',
		value: function setGuestQuestion(index, question, value) {
			this.setState(function (state) {
				var G = state.guests.slice();
				G[index].questions[question] = value;
				return { guests: G };
			});
		}
	}, {
		key: 'setGlobalQuestion',
		value: function setGlobalQuestion(question, value) {
			this.setState(function (state) {
				return { questions: Object.assign({}, state.questions, _defineProperty({}, question, value)) };
			});
		}
	}, {
		key: 'submit',
		value: function submit() {
			var _this5 = this;

			var D = Object.assign({}, this.state, { eventID: this.props.event.eventID });
			this.setState({ submitting: true });
			delete D.submitting;
			delete D.submitted;
			var xhr = new XMLHttpRequest();
			xhr.open('POST', 'data/event-registration', true);
			xhr.setRequestHeader('Content-Type', 'application/json');
			var timerFinished = false;
			var requestFinished = false;
			var done = function done() {
				if (timerFinished && requestFinished) {
					_this5.setState({ submitting: false, submitted: true });
				}
			};
			var timer = setTimeout(function () {
				timerFinished = true;
				done();
			}, 2000);
			xhr.onreadystatechange = function () {
				if (xhr.readyState == 4) {
					requestFinished = true;
					done();
				}
			};
			xhr.send(JSON.stringify(D));
		}
	}, {
		key: 'canSubmit',
		get: function get() {
			if (this.state.name && this.state.phone && this.state.email) {
				// If any guest entry is there but has nothing in it, treat it as an item to ignore.
				for (var i = 0; i < this.state.guests.length; i++) {
					if (this.state.guests[i].name) continue;
					for (var j in this.state.guests[i].questions) {
						if (this.state.guests[i].questions[j]) return false;
					}
				}
				return true;
			}
			return false;
		}
	}]);

	return RegisterForEvents;
}(_react.Component);

exports.default = RegisterForEvents;